import { render, staticRenderFns } from "./MediaManage.vue?vue&type=template&id=3c2084fa&scoped=true"
import script from "./MediaManage.vue?vue&type=script&lang=js"
export * from "./MediaManage.vue?vue&type=script&lang=js"
import style0 from "./MediaManage.vue?vue&type=style&index=0&id=3c2084fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2084fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2084fa')) {
      api.createRecord('3c2084fa', component.options)
    } else {
      api.reload('3c2084fa', component.options)
    }
    module.hot.accept("./MediaManage.vue?vue&type=template&id=3c2084fa&scoped=true", function () {
      api.rerender('3c2084fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/media/MediaManage.vue"
export default component.exports